import React, { useState } from 'react';

const OPCRegistration = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formStatus, setFormStatus] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: 'I need help with OPC registration.',
    website_hp: ''
  });

   const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFormSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);
  
  try {
    const response = await fetch("https://akiradvisory.in/send_mail.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      setFormStatus('success');
      // Reset form while keeping the default message
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: 'I need help with OPC registration.',
        website_hp: ''
      });
    } else {
      setFormStatus('error');
    }
  } catch (error) {
    setFormStatus('error');
  } finally {
    setIsSubmitting(false);
    setTimeout(() => setFormStatus(''), 5000);
  }
};

  return (
    <main>
      {/* Hero Section */}
      <section className="relative bg-blue-700 pt-16 pb-12">
        <div className="absolute inset-0 opacity-10 bg-cover bg-center"></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="lg:w-2/3">
            <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-white leading-tight">
              OPC Registration
            </h1>
            <p className="mt-4 text-xl text-blue-100">
              The best way for a single entrepreneur to start a formal, protected business.
            </p>
            <div className="mt-8">
              <a href="#contact-section" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
                  <span className="mr-2">👤</span> Start OPC Registration Now
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Sticky Navigation */}
      <section className="bg-gray-50 border-b border-gray-200 sticky top-16 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <ul className="flex space-x-6 overflow-x-auto text-sm font-medium">
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#details">Overview & Benefits</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#procedure">Registration Process</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#documents">Documents Required</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#you-get">What You Get</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#service-faqs">FAQs</a></li>
            </ul>
        </div>
      </section>

      {/* Overview Section */}
      <section id="details" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2 space-y-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4 border-b pb-2">
                Overview of One Person Company (OPC)
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                A <strong>One Person Company (OPC)</strong> is a company where only one shareholder holds 100% of the stake and also acts as a director. It allows an entrepreneur to operate a business with a single-person control while enjoying the benefits of limited liability. Governed by the Companies Act, 2013, it requires a Director Nominee who has zero power until the real director proves incapable of carrying on.
              </p>
              
              <h3 className="text-2xl font-bold text-blue-600 mb-4">
                Key Features & Benefits
              </h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                  <div>
                      <strong className="font-semibold">Limited Liability:</strong> The director's personal assets are protected from the liabilities and losses of the company.
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                  <div>
                      <strong className="font-semibold">Single-Person Control:</strong> The sole member/director has complete control over decision-making.
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                  <div>
                      <strong className="font-semibold">Increased Legitimacy:</strong> Enhanced brand awareness and legitimacy compared to a proprietorship firm.
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                  <div>
                      <strong className="font-semibold">Easier Compliance:</strong> Fewer statutory compliance requirements compared to a Private Limited Company.
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                  <div>
                      <strong className="font-semibold">Ease of Share Transfer:</strong> Simpler process for future transfer or conversion, providing greater flexibility.
                  </div>
                </li>
              </ul>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-1" id="contact-section">
              <div className="bg-gray-50 p-6 rounded-xl shadow-xl border-t-4 border-blue-600 sticky top-28">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                  Quick Enquiry
                </h3>
                
                {formStatus === 'success' && (
                  <div className="p-4 bg-green-100 text-green-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">✅</span>
                    Thank you! Your enquiry has been submitted. We'll contact you shortly.
                  </div>
                )}

                {formStatus === 'error' && (
                  <div className="p-4 bg-red-100 text-red-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">❌</span>
                    There was an error submitting your form. Please try again.
                  </div>
                )}

                <form className="space-y-4" onSubmit={handleFormSubmit}>
                  <input 
                    type="text" 
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Your Full Name" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="email" 
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Email Address" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="tel" 
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Phone Number" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <textarea 
                    rows="3" 
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="I need help with OPC registration." 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required
                  ></textarea>
                  <button 
                    type="submit" 
                    disabled={isSubmitting}
                    className="w-full py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition disabled:bg-blue-400 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? (
                      <>
                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3 inline-block"></div>
                        Submitting...
                      </>
                    ) : (
                      'Request an Initial Consultation'
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Procedure Section */}
      <section id="procedure" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Our Simple Process
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              8 Steps for One Person Company (OPC) Registration
            </p>
          </div>
          
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-6 grid-flow-row-dense">
            {[
              { number: "01", icon: "📊", title: "Information & Query", desc: "Collect Director/Nominee details and 50% advance payment." },
              { number: "02", icon: "🔒", title: "Procure DSC & DIN", desc: "Application for Digital Signature Certificate and Director Identification Number." },
              { number: "03", icon: "🏢", title: "Company Name Approval", desc: "Filing for the proposed company name with the Ministry of Corporate Affairs (MCA)." },
              { number: "04", icon: "📝", title: "Drafting & Document Signing", desc: "Preparation and signing of MOA, AOA, and other incorporation documents." },
              { number: "05", icon: "💳", title: "Final Payment & MCA Filing", desc: "Receive balance 50% payment and file final documents for registration." },
              { number: "06", icon: "🖋️", title: "Issuance of Certificate", desc: "The Registrar of Companies (ROC) issues the Certificate of Incorporation." },
              { number: "07", icon: "🆔", title: "PAN & TAN Allotment", desc: "The company's Permanent Account Number (PAN) and Tax Deduction Account Number (TAN) are generated." },
              { number: "08", icon: "📬", title: "Final Document Delivery", desc: "We send you the complete set of incorporation documents, MOA, AOA, and acknowledgements." }
            ].map((step, index) => (
              <div key={index} className="sm:col-span-2 lg:col-span-2 p-4 bg-white rounded-xl shadow-lg text-center hover:shadow-xl transition-shadow border-t-4 border-blue-500 h-full">
                <div className="procedure-step-content">
                  <div>
                    <span className="text-2xl font-extrabold text-blue-600 block mb-2">{step.number}</span>
                    <span className="text-2xl mx-auto mb-2 block">{step.icon}</span>
                    <h3 className="text-lg font-bold text-gray-900 mb-1">{step.title}</h3>
                  </div>
                  <p className="text-gray-600 text-sm mt-3">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Documents Section */}
      <section id="documents" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Only Scanned Copies are required
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Mandatory Documents for OPC Registration
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: "🆔", title: "PAN Card", desc: "PAN card copy of the Director and Shareholder." },
              { icon: "👥", title: "ID Proof of Nominee", desc: "Identity proof (Aadhaar/Voter ID/Passport/DL) of the Nominee." },
              { icon: "👤", title: "Photo ID Proof of Director", desc: "Voter Card, Passport, or Driving Licence of the Director/Shareholder." },
              { icon: "🏠", title: "Registered Office Proof", desc: "Rent Agreement + NOC + Latest Utility Bill (must be less than 30 Days)." },
              { icon: "📷", title: "Passport Size Photos", desc: "Latest passport size photograph of the Director/Shareholder." },
              { icon: "📍", title: "Director's Address Proof", desc: "Bank Statement, Mobile bill, or Telephone bill (less than 2 months old)." }
            ].map((doc, index) => (
              <div key={index} className="p-6 border rounded-xl shadow-md flex items-start space-x-4 h-full">
                <span className="text-2xl flex-shrink-0 mt-1">{doc.icon}</span>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">{doc.title}</h3>
                  <p className="text-gray-600 text-sm mt-1">{doc.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What You Get Section */}
      <section id="you-get" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Your Deliverables
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              What Akir Advisory Delivers
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { icon: "📋", title: "Incorporation Certificate & Name Approval", desc: "The official Business Incorporation Certificate and the Name Approval Letter from the MCA." },
              { icon: "📚", title: "AOA and MOA", desc: "The legal Articles of Association (AOA) and Memorandum of Association (MOA) of your OPC." },
              { icon: "🆔", title: "Company PAN & TAN", desc: "The Permanent Account Number (PAN) and Tax Deduction Account Number (TAN) for the company." },
              { icon: "🔐", title: "DIN & DSC for 1 Director", desc: "Director Identification Number (DIN) and Digital Signature Certificate (DSC) for the Director." }
            ].map((item, index) => (
              <div key={index} className="p-6 bg-white rounded-xl shadow-lg border-l-4 border-green-500 h-full flex flex-col">
                <span className="text-2xl mb-3 block">{item.icon}</span>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQs Section */}
      <section id="service-faqs" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Common Questions
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              OPC Registration FAQs
            </p>
          </div>
          
          <div className="space-y-4 max-w-4xl mx-auto">
            <div className="border rounded-lg p-5 shadow-sm">
              <h4 className="font-semibold text-lg text-gray-900 mb-2">What is the minimum requirement for an OPC?</h4>
              <p className="text-gray-600">The minimum requirements include only <strong>one director</strong> and <strong>one member</strong>, who must be a resident of India. There is no minimum paid-up share capital requirement to start an OPC.</p>
            </div>
            <div className="border rounded-lg p-5 shadow-sm">
              <h4 className="font-semibold text-lg text-gray-900 mb-2">What happens if my OPC crosses the turnover limit?</h4>
              <p className="text-gray-600">If an OPC has an average annual turnover of <strong>₹2 crores or more</strong> for three consecutive years, or if its paid-up capital exceeds <strong>₹50 lakhs</strong>, it must be mandatorily converted into a Private Limited Company or Public Limited Company within six months.</p>
            </div>
            <div className="border rounded-lg p-5 shadow-sm">
              <h4 className="font-semibold text-lg text-gray-900 mb-2">Is a nominee compulsory in an OPC?</h4>
              <p className="text-gray-600">Yes, a nominee is <strong>compulsory</strong>. The sole member must name a nominee in the Memorandum of Association (MOA) who will take over the company in case of the member's death or incapacity. The nominee must also be an Indian resident and give their consent.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-16 bg-blue-700/90">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-extrabold text-white">
            Ready to Form Your One Person Company?
          </h2>
          <p className="mt-4 text-xl text-blue-100 max-w-3xl mx-auto">
            Our experts will guide you through the seamless registration process with a fixed, affordable fee.
          </p>
          <a href="#contact-section" className="mt-8 inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
            <span className="mr-2">📞</span>  Consult Our Expert Today
          </a>
        </div>
      </section>
    </main>
  );
};

export default OPCRegistration;